var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.maxPointFilter.length !== 0)?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":_vm.$t('addcomm.By Price') +
        '  (' +
        this.minPoint +
        '-' +
        this.maxPoint +
        ')',"bordered":false}},[_c('a-slider',{attrs:{"range":"","max":this.maxPoint,"min":this.minPoint,"default-value":[this.minPointFilter, this.maxPointFilter]},on:{"afterChange":function($event){return _vm.getSliderValue($event)}}}),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(this.minPointFilter + "-" + this.maxPointFilter)+" ")])],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }